import styled from "styled-components";
/**
 * Each `FormFieldGroup` in a `FormRepeatedGroup` usually has two parts -
 * the form field components, and the controls for the repeated group.
 *
 * The ButtonContainer styles the control components correctly within
 * the repeated group. It currently expects either a 2-column or
 * 4-column layout based on the common combinations of repeated group
 * controls.
 */
export const ButtonContainer = styled.div `
  gap: 7px;
  height: 24px;
  display: inline-grid;
  padding-top: 8px;
  grid-template-rows: 1fr;
  grid-template-columns: ${({ numButtons }) => (numButtons === 2 ? "16px 16px" : "16px 16px 16px 16px")};
  align-self: flex-end;
  margin-bottom: 24px;
  margin-left: 4px;
`;
